import * as React from 'react';
import { UseSelectGetLabelPropsOptions } from 'downshift';

interface LabelProps {
  label: string;
  classes: Record<string, string>;
  hideLabel: boolean;
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLabelProps: (options?: UseSelectGetLabelPropsOptions) => any;
}
export const Label: React.FC<LabelProps> = ({ label, classes, hideLabel, id, getLabelProps }) => (
  <label
    {...getLabelProps({ className: `${classes.label} ${hideLabel ? classes.isVisuallyHidden : ''}`, htmlFor: id })}
  >
    {label}
  </label>
);
